import { Injectable } from '@angular/core';
import { CaptchaDialogComponent } from '../common/captcha-dialog/captcha-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class CaptchaDialogService {
  private captchaDialog?: CaptchaDialogComponent;

  setCaptchaDialog(dialog: CaptchaDialogComponent): void {
    this.captchaDialog = dialog;
  }

  openCaptchaDialog(): void {
    this.captchaDialog?.openDialog();
    this.captchaDialog?.reloadCaptcha();
  }
}
